import {Component, OnInit} from '@angular/core';
import {BaseRecordTableItemComponent} from '../base-record-table-item/base-record-table-item.component';
import {MatChipEditedEvent} from '@angular/material/chips';

@Component({
  selector: 'app-chips-record-table-item',
  standalone: false,
  templateUrl: './chips-record-table-item.component.html',
  styleUrls: [
    '../base-record-table-item-styles.scss',
    './chips-record-table-item.component.scss'
  ]
})
export class ChipsRecordTableItemComponent extends BaseRecordTableItemComponent implements OnInit {
  public chipsValues: Array<string> = [];
  public inputValue: string = '';

  public ngOnInit() {
    this.prepareChipsValues();
  }

  public prepareChipsValues(): void {
    if (this.value === undefined) { return; }
    this.chipsValues = String(this.value).split(',');
  }

  public updateChipsValues(newChipsValues: Array<string>): void {
   this.chipsValues = newChipsValues;
   this.value = this.chipsValues.join(',');
   this.handleValueChange(this.value);
  }

  public addChips(chipsValue: string): void {
    if (!chipsValue.trim()) { return; }

    this.updateChipsValues([...this.chipsValues, chipsValue]);
    this.inputValue = '';
  }

  public removeChips(chipsValue: string): void {
    const removingChipsIndex = this.findChipsIndexByChipsValue(chipsValue);
    this.chipsValues.splice(removingChipsIndex, 1);
    this.updateChipsValues(this.chipsValues);
  }

  public editChips(editEvent: MatChipEditedEvent, oldValue: string) {
    const chipsValue = editEvent.value.trim();
    const editingChipsValue = this.findChipsIndexByChipsValue(oldValue);
    this.chipsValues[editingChipsValue] = chipsValue;
    this.updateChipsValues(this.chipsValues);
  }

  private findChipsIndexByChipsValue(chipsValue: string): number {
    return this.chipsValues.findIndex((chips: string) => chips === chipsValue);
  }
}
